import {
    DELETE_NOTES_REQUEST,
    DELETE_NOTES_SUCCESS,
    DELETE_NOTES_ERROR
  } from "./DeleteNotesTypes";
  
  const initialState = {
    loading: false,
    isSubmitted: false,
    successMessage: "",
    errorMessage: "",
    deleteNotes: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case DELETE_NOTES_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case DELETE_NOTES_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          deleteNotes: action.payload,
          successMessage: "Notes deleted successfully!",
          errorMessage: ""
        };
      case DELETE_NOTES_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          deleteNotes: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  